export default "__VITE_ASSET__BpAwDhjz__"